import { Input } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

export const DateComponent = ({ value, onChange, disabledField }) => {
  const dateFormat = 'YYYY-MM-DD';
  const [dateValue, setSelectedDateValue] = useState(null);

  const updateValue = (newValue) => {
    setSelectedDateValue(newValue);
    onChange(newValue?.toDate());
  };

  const setValues = (date) => {
    updateValue(moment(date, dateFormat));
  };

  const getDateValue = () => {
    return dateValue?.format(dateFormat);
  };

  const onChangeDate = (e) => {
    const date = e.target.value;
    if (!date) updateValue(null);
    setValues(date);
  };

  useEffect(() => {
    if (value == null || Number.isNaN(value)) return;
    setSelectedDateValue(moment(value));
  }, []);

  return (
    <>
      <Input type="date" value={getDateValue()} onChange={onChangeDate} disabled={disabledField} />
    </>
  );
};

DateComponent.propTypes = {
  // field: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};
